import { useEffect } from 'react'
import { initMetaPixel } from '../utils/metaPixel'

/** Carga el píxel de Meta una sola vez, después del primer render. */
export function useMetaPixel(): void {
  useEffect(() => {
    initMetaPixel()
  }, [])
}
